import { Injectable } from '@angular/core';

import { ApiPaymentMethods } from '@api/_api/api-order/api-order.models';
import { StaticResourceService } from '@core/services/static-resource.service';

@Injectable()
export class ApiMiniPaymentMethodsTransformer {
    constructor(
        private readonly staticResourceService: StaticResourceService,
    ) {}

    public fromApi(data: ApiPaymentMethods, sort: string[]): Array<[string, string]> {
        return data.paymentMethods
            .filter((method) => sort.includes(method.code))
            .sort((a, b) => sort.indexOf(a.code) - sort.indexOf(b.code))
            .map((method) => [method.name, this.staticResourceService.getPaymentLogo(method)]);
    }
}
